'use strict';

const personType = {
  LEGAL: 'legal',
  PHYSICAL: 'physical'
};

module.exports = personType;
